export default [
    {
        id: 'transport-permits-module',
        title: 'Модуль выдачи транспортных разрешений',
        iconValue: 'item-check',
        disabled: (ctx) => !ctx.$checkPermission('eputs_transport_permits_access'),
        isArchived: true,
    },
    {
        id: 'traffic-enforcement-module',
        title: 'Модуль администрирования транспортных правонарушений',
        iconValue: 'penalty',
        disabled: (ctx) => !ctx.$checkPermission('eputs_traffic_enforcement_access'),
        isArchived: true,
    },
    {
        id: 'emergency-module',
        title: 'Модуль диспетчерского управления ИТС для ЧС и ВС',
        iconValue: 'bell-emergency',
        disabled: (ctx) => !ctx.$checkPermission('eputs_emergency_access'),
        isArchived: true,
    },
    {
        id: 'its_monitoring',
        title: 'Модуль контроля эффективности ИТС',
        iconValue: 'its-module-icon',
        disabled: (ctx) => !ctx.$checkPermission('eputs_its_access'),
        isArchived: true,
    },
    {
        id: 'road-works-module',
        title: 'Модуль управления дорожными работами',
        iconValue: 'roadworks-module-icon',
        disabled: (ctx) => !ctx.$checkPermission('eputs_road_works_access'),
        isArchived: true,
    },
    {
        id: 'informing-module',
        title: 'Модуль централизованного информирования участников движения',
        iconValue: 'informing-module-icon',
        disabled: (ctx) => !ctx.$checkPermission('eputs_informing_access'),
        isArchived: true,
    },
    {
        id: 'public-transport-module',
        title: 'Модуль управления движением общественного транспорта',
        iconValue: 'public-transport-module-icon',
        disabled: (ctx) => !ctx.$checkPermission('eputs_public_transport_access'),
        isArchived: true,
    },
    {
        id: 'io-module',
        title: 'Модуль внутренних и внешних сервисов',
        iconValue: 'io-module-icon',
        disabled: (ctx) => !ctx.$checkPermission('eputs_io_access'),
        isArchived: true,
    },
    {
        id: 'parking-module',
        title: 'Модуль конфигурации парковочного пространства',
        iconValue: 'parking-module-icon',
        disabled: (ctx) => !ctx.$checkPermission('eputs_parking_access'),
        isArchived: true,
    },
    {
        id: 'modeling-module',
        title: 'Модуль транспортного прогнозирования и моделирования',
        iconValue: 'modeling-module-icon',
        disabled: (ctx) => !ctx.$checkPermission('eputs_modeling_access'),
        isArchived: true,
    },
    {
        id: 'twin-module',
        title: 'Модуль "Цифровой двойник"',
        iconValue: 'twin-module-icon',
        disabled: (ctx) => !ctx.$checkPermission('eputs_twin_access'),
        isArchived: true,
    },

    {
        id: 'traffic-camera-map',
        title: 'Подсистема видеонаблюдения, детектирования ДТП и ЧС',
        iconValue: 'tcm-icon',
        disabled: (ctx) => !ctx.$checkPermission('eputs_tcm_module_access'),
        isArchived: false,
    },
    {
        id: 'its-grade',
        title: 'Подсистема комплексной оценки ИТС',
        iconValue: 'its-grade-icon',
        disabled: (ctx) => !ctx.$checkPermission('eputs_its_grade_module_access'),
        isArchived: false,
    },
    {
        id: 'pvr-map',
        title: 'Подсистема контроля комплексов ФВФ',
        iconValue: 'pvr-icon',
        disabled: (ctx) => !ctx.$checkPermission('eputs_pvr_module_access'),
        isArchived: false,
    },
    {
        id: 'dtp-map',
        title: 'Подсистема анализа аварийности в РТ',
        iconValue: 'dtp-icon',
        disabled: (ctx) => !ctx.$checkPermission('eputs_dtp_map_module_access'),
        isArchived: false,
    },
    {
        id: 'parking-map',
        title: 'Подсистема мониторинга парковочного пространства',
        iconValue: 'parking-module-icon',
        disabled: (ctx) => !ctx.$checkPermission('eputs_parking_map_module_access'),
        isArchived: false,
    },
    {
        id: 'ktg-map',
        title: 'Подсистема учета проездов крупногабаритных ТС',
        iconValue: 'ktg-icon',
        disabled: (ctx) => !ctx.$checkPermission('eputs_ktg_module_access'),
        isArchived: false,
    },
    {
        id: 'minister-module',
        title: 'Министр',
        // icon: 'module-icon-15',
        disabled: false,
    },
    {
        id: 'sit-center',
        title: 'Ситуационный центр',
        // icon: 'module-icon-15',
        disabled: false,
    },
    {
        id: 'admin',
        title: 'Управление пользователями и доступом',
    },
    {
        id: 'dictionary',
        title: 'Справочная информация',
    },
];
